import { render, staticRenderFns } from "./BlackFourthPrize.vue?vue&type=template&id=740cbb58&scoped=true&"
import script from "./BlackFourthPrize.vue?vue&type=script&lang=js&"
export * from "./BlackFourthPrize.vue?vue&type=script&lang=js&"
import style0 from "./BlackFourthPrize.vue?vue&type=style&index=0&id=740cbb58&prod&lang=less&scoped=true&"
import style1 from "./BlackFourthPrize.vue?vue&type=style&index=1&id=740cbb58&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740cbb58",
  null
  
)

export default component.exports